import { render, staticRenderFns } from "./AgentForm.vue?vue&type=template&id=9722e32c&"
import script from "./AgentForm.vue?vue&type=script&lang=js&"
export * from "./AgentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports